import { useEffect, useRef } from 'react';

const BUSINESS_UNIT_ID = process.env.REACT_APP_TRUSTPILOT_BUSINESS_UNIT_ID;
// Review Collector ("Review us on Trustpilot") is the only TrustBox on every
// plan; star-rating templates such as Mini (53aa8807dec7e10d38f59f32) need a
// paid plan and otherwise answer 400. Set REACT_APP_TRUSTPILOT_TEMPLATE_ID to
// use one.
const TEMPLATE_ID = process.env.REACT_APP_TRUSTPILOT_TEMPLATE_ID || '56278e9abfbbba0bdcd568bc';
const REVIEW_COLLECTOR = TEMPLATE_ID === '56278e9abfbbba0bdcd568bc';

/**
 * Trustpilot TrustBox widget — Review Collector by default (see TEMPLATE_ID).
 *
 * Safety notes:
 * - Returns null if REACT_APP_TRUSTPILOT_BUSINESS_UNIT_ID is not set,
 *   so the homepage renders cleanly in dev/CI without the key.
 * - loadFromElement is wrapped in try/catch because ad-blockers can make
 *   window.Trustpilot partially initialised, causing unexpected throws.
 * - Fallback <a> is shown when the widget script is blocked entirely.
 *
 * React SPA note: Trustpilot's bootstrap script runs once on the first
 * HTML load and does not re-scan the DOM on route changes. We call
 * loadFromElement() in useEffect to re-initialise on each mount.
 */
export default function TrustpilotWidget() {
  const ref = useRef(null);

  useEffect(() => {
    if (!BUSINESS_UNIT_ID) return;
    if (!window.Trustpilot || !ref.current) return;
    try {
      window.Trustpilot.loadFromElement(ref.current, true);
    } catch (_) {
      // Silent — never crash the page over a trust widget
    }
  }, []);

  if (!BUSINESS_UNIT_ID) return null;

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id={TEMPLATE_ID}
      data-businessunit-id={BUSINESS_UNIT_ID}
      data-style-height={REVIEW_COLLECTOR ? '52px' : '120px'}
      data-style-width="100%"
      data-theme="light"
    >
      {/* Shown only when the widget script is blocked by an ad-blocker */}
      <a
        href="https://www.trustpilot.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
}
